import { DEFAULT_SOCIAL_IMAGE, SITE_DESCRIPTION, SITE_NAME, absoluteSiteUrl } from '../config/site'
import { serviceMenus } from '../data/services'
import { contact, teamMembers } from '../data/site'

const salonId = absoluteSiteUrl('/#salon')

const salonSchema = {
  '@context': 'https://schema.org',
  '@type': 'HairSalon',
  '@id': salonId,
  name: SITE_NAME,
  description: SITE_DESCRIPTION,
  url: absoluteSiteUrl('/'),
  image: absoluteSiteUrl(DEFAULT_SOCIAL_IMAGE),
  logo: absoluteSiteUrl('/images/diamondlogo.png'),
  telephone: contact.phoneDisplay,
  email: contact.email,
  address: {
    '@type': 'PostalAddress',
    streetAddress: '31831 Camino Capistrano Ste 201',
    addressLocality: 'San Juan Capistrano',
    addressRegion: 'CA',
    postalCode: '92675',
    addressCountry: 'US',
  },
  openingHoursSpecification: [
    {
      '@type': 'OpeningHoursSpecification',
      dayOfWeek: ['Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
      opens: '09:00',
      closes: '17:00',
    },
  ],
  sameAs: [contact.instagramUrl, contact.yelpUrl],
  potentialAction: {
    '@type': 'ReserveAction',
    target: contact.bookingUrl,
    name: 'Book an appointment',
  },
}

const peopleSchema = teamMembers.map((member) => ({
  '@context': 'https://schema.org',
  '@type': 'Person',
  name: member.name,
  jobTitle: member.role,
  ...(member.bio[0] ? { description: member.bio[0] } : {}),
  ...(member.image ? { image: absoluteSiteUrl(`/${member.image.fallback}`) } : {}),
  ...(member.instagram ? { sameAs: [member.instagram] } : {}),
  worksFor: { '@id': salonId },
  url: absoluteSiteUrl('/team'),
}))

const serviceSchema = (Object.entries(serviceMenus) as [string, (typeof serviceMenus)[keyof typeof serviceMenus]][]).map(([key, menu]) => ({
  '@context': 'https://schema.org',
  '@type': 'Service',
  name: key === 'salon' ? 'Hair salon services' : 'Spa services',
  description: menu.introduction,
  provider: { '@id': salonId },
  url: absoluteSiteUrl(`/services?view=${key}`),
  hasOfferCatalog: {
    '@type': 'OfferCatalog',
    name: menu.eyebrow,
    itemListElement: menu.categories.map((category) => ({
      '@type': 'OfferCatalog',
      name: category.title,
      description: category.description,
    })),
  },
}))

export function getRouteStructuredData(pathname: string) {
  if (pathname === '/404' || pathname === '/privacy-policy') return []
  if (pathname === '/team') return [salonSchema, ...peopleSchema]
  if (pathname === '/services') return [salonSchema, ...serviceSchema]
  return [salonSchema]
}
